'use client';

import { useCallback, useState } from 'react';
import { useIntakeWizardContext } from '../../contexts/WizardProvider';
import { useWizardNavigation } from '../../hooks/useWizardNavigation';
import { CheckboxGroup } from '../common/CheckboxGroup';
import { IntakeStepWrapper } from '../common/IntakeStepWrapper';

const REASON_OPTIONS = [
  {
    value: '24/7 access to concierge immediate care',
    label: '24/7 access to concierge immediate care',
  },
  {
    value: 'Avoiding ER or urgent care visits',
    label: 'Avoiding ER or urgent care visits',
  },
  {
    value: 'Imaging (X-ray, ultrasound, MRI, CT)',
    label: 'Imaging (X-ray, ultrasound, MRI, CT)',
  },
  {
    value: 'Expedited access to top specialists and hospitals',
    label: 'Expedited access to top specialists and hospitals',
  },
  {
    value: 'Support managing an ongoing health condition',
    label: 'Support managing an ongoing health condition',
  },
  {
    value: 'Medical peace of mind',
    label: 'Medical peace of mind',
  },

  { value: 'Other', label: 'Other' },
];

export const ReasonsStep = () => {
  const { state, dispatch } = useIntakeWizardContext();
  const { goToNextStep, goToPreviousStep, hasPreviousStep } =
    useWizardNavigation();
  const [error, setError] = useState<string | undefined>();

  // Read directly from wizard state
  const reasons = state.formData?.reasons || [];

  const handleChange = useCallback(
    (values: string[]) => {
      dispatch({
        type: 'SET_FORM_DATA',
        payload: { reasons: values },
      });
      setError(undefined);
    },
    [dispatch]
  );

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();

      if (reasons.length === 0) {
        setError('Please select at least one option');
        return;
      }

      goToNextStep();
    },
    [reasons.length, goToNextStep]
  );

  return (
    <IntakeStepWrapper
      heading='What brings you to Sollis today?'
      description='Select all that apply.'
      onSubmit={handleSubmit}
      onBack={goToPreviousStep}
      showBack={hasPreviousStep}
    >
      <CheckboxGroup
        name='reasons'
        options={REASON_OPTIONS}
        values={reasons}
        onChange={handleChange}
        error={error}
      />
    </IntakeStepWrapper>
  );
};
